import NotVerifiedBadge from './NotVerifiedBadge.component';

export default NotVerifiedBadge;
